import { defineTranslation } from './define';

export const ar = defineTranslation({
  "state.unavailableBody": "صفحة الدفع هذه غير متاحة مؤقتًا. يُرجى المحاولة مرة أخرى لاحقًا.",
  "action.accessExpired": "انتهت صلاحية هذا الوصول أو لم يعد متاحًا. اطلب رابطًا جديدًا للمتابعة.",
  "action.requestLink": "إرسال رابط جديد",
  "action.linkSent": "إذا كان هذا الوصول صالحًا، فسنرسل رابطًا جديدًا إلى البريد الإلكتروني المسجل.",
  "action.accessProcessing": "قد تكون الدفعة قيد المعالجة. اطلب رابطًا جديدًا للتحقق من حالتها. لا تدفع مرة أخرى.",

  "error.priceChangedTitle": "بيانات غير محدثة",
  "block.PRECO_ALTERADO": "بيانات هذا الشراء غير محدثة. حدّث الصفحة وتحقق من المبلغ قبل المتابعة.",
  "error.refresh": "تحديث الصفحة",
  "error.priceRefreshed": "تم تحديث سعر الصرف. راجع السعر وأكد مرة أخرى للمتابعة.",
  "summary.loading": "جارٍ تحميل ملخص الطلب",
  "summary.unavailableTitle": "ملخص الطلب غير متاح",
  "summary.unavailableBody": "تعذر تحميل التفاصيل. راجع رسالة تأكيد الشراء في بريدك الإلكتروني.",
  "summary.mainPurchase": "الشراء الرئيسي",
  "summary.additionalOffer": "عرض إضافي",
  "upsell.protectedOffer": "عرض محمي",
  "upsell.storageTitle": "أكّد لعرض العرض الخاص بك",
  "upsell.storageDeniedTitle": "العرض غير متاح في هذا المتصفح",
  "upsell.storageBody": "يحمي متصفحك البيانات بين المواقع. اسمح لـ VendePay بتحميل هذا العرض بأمان.",
  "upsell.storageDeniedBody": "لم يسمح المتصفح بالوصول على هذا الموقع. افتح العرض بأمان على VendePay أو تابع من دونه.",
  "upsell.loading": "جارٍ التحميل…",
  "upsell.loadOffer": "تحميل العرض",
  "upsell.openHosted": "فتح العرض على VendePay",
  "error.retry": "حاول مرة أخرى",
  "error.systemTitle": "حدث خطأ",
  "error.validationTitle": "تحقق من بياناتك",
  "error.paymentTitle": "لم يكتمل الدفع",
  "action.processingTitle": "جارٍ معالجة الدفع",
  "action.canceledTitle": "تم طلب الإلغاء",
  "action.alreadyCanceledTitle": "الاشتراك ملغى بالفعل",
  "action.cardUpdatedTitle": "تم تحديث البطاقة",
  "action.paidTitle": "تمت معالجة الدفع",
  "action.cancelTitle": "إلغاء الاشتراك",
  "action.cardTitle": "تغيير البطاقة",
  "action.payTitle": "دفع الفاتورة",
  "action.loading": "جارٍ تحميل الرابط…",
  "action.canceledBody": "سينتهي الاشتراك في نهاية الفترة الحالية.",
  "action.alreadyCanceledBody": "لا تحتاج إلى طلب الإلغاء مرة أخرى.",
  "action.cardUpdatedBody": "تم تحديث بطاقة الاشتراك. يمكنك إغلاق هذه الصفحة.",
  "action.paidBody": "تم تحديث الفاتورة. يمكنك إغلاق هذه الصفحة.",
  "action.processingBody": "تم تأكيد الخصم وهو بانتظار التسوية من مقدم الخدمة. لا تحاول الدفع مرة أخرى.",
  "action.plan": "الخطة",
  "action.status": "الحالة",
  "action.invoice": "الفاتورة",
  "action.period": "الفترة الحالية",
  "action.until": "حتى {{date}}",
  "action.authentication": "طلب البنك تأكيدًا أمنيًا لبطاقتك.",
  "action.cancelButton": "الإلغاء في نهاية الفترة",
  "action.saveButton": "حفظ البطاقة",
  "action.authenticateButton": "المصادقة على البطاقة",
  "action.payButton": "الدفع الآن",
  "action.trialing": "فترة تجريبية",
  "action.active": "نشط",
  "action.pastDue": "متأخر السداد",
  "action.canceled": "ملغى",
  "action.pending": "معلق",
  "action.processing": "قيد المعالجة",
  "action.awaitingAction": "بانتظار إجراء",
  "action.paid": "مدفوعة",
  "action.inGrace": "فترة سماح",
  "action.failed": "فشلت",
  'language.select': 'اللغة', 'common.demo': 'عرض تجريبي', 'common.emailFallback': 'بريدك الإلكتروني',
  'common.processing': 'جارٍ المعالجة…', 'common.free': 'مجانًا', 'common.today': 'اليوم', 'common.total': 'الإجمالي',
  'common.unavailable': 'غير متاح', 'common.onRequest': 'عند الطلب',
  'period.minute.one': 'دقيقة', 'period.minute.other': 'دقائق',
  'period.day.one': 'يوم', 'period.day.other': 'أيام', 'period.week.one': 'أسبوع', 'period.week.other': 'أسابيع',
  'period.month.one': 'شهر', 'period.month.other': 'أشهر', 'period.year.one': 'سنة', 'period.year.other': 'سنوات',
  'period.single': '/{{unit}}', 'period.every': ' كل {{count}} {{unit}}', 'period.for': 'لكل {{unit}}',
  'field.name': 'الاسم الكامل', 'field.namePlaceholder': 'كما هو في مستندك', 'field.email': 'البريد الإلكتروني',
  'field.emailPlaceholder': 'you@email.com', 'field.phone': 'الهاتف / واتساب',
  'field.internationalPhone': 'هاتف دولي (اختياري)', 'field.internationalPhonePlaceholder': '+ رمز الدولة والرقم',
  'field.document': 'المستند', 'field.documentPlaceholder': 'رقم المستند',
  'pii.email': 'بريدي الإلكتروني', 'pii.phone': 'رقم هاتفي', 'pii.emailPhone': 'بريدي الإلكتروني ورقم هاتفي',
  'pii.optional': 'اختياري: لا يؤثر في عملية الشراء',
  'pii.consent': 'أوافق على استخدام {{target}} بعد حمايته بالتجزئة لقياس تحويل الإعلانات لهذه العملية.',
  'state.loading': 'جارٍ تحميل صفحة الدفع…', 'state.notFoundTitle': 'صفحة الدفع غير متاحة',
  'state.notFoundBody': 'صفحة الدفع هذه غير موجودة أو لم تعد نشطة.', 'state.errorTitle': 'حدث خطأ ما',
  'state.errorBody': 'تعذر تحميل صفحة الدفع الآن. حاول مرة أخرى بعد قليل.',
  'error.payment': 'تعذر إكمال الدفع.', 'error.cardDetails': 'تحقق من بيانات البطاقة.',
  'error.checkoutUnavailable': 'صفحة الدفع هذه غير متاحة للشراء حاليًا.',
  'error.subscriptionCardOnly': 'لا يمكن دفع الاشتراكات إلا بالبطاقة.',
  'error.emailRequired': 'أدخل بريدك الإلكتروني لإكمال الشراء.', 'error.emailInvalid': 'أدخل بريدًا إلكترونيًا صالحًا لإكمال الشراء.',
  'error.confirmationExpired': 'انتهت مهلة التأكيد. حاول مرة أخرى.',
  'error.authentication': 'تعذر إكمال مصادقة البطاقة.', 'error.offerUnavailable': 'هذا العرض غير متاح حاليًا.',
  'error.offerProcessing': 'تعذرت معالجة العرض.',
  'decline.currency_not_supported': 'هذه البطاقة لا تدعم عملة هذا الشراء. جرّب بطاقة أخرى أو طريقة دفع أخرى.',
  'decline.card_not_supported': 'هذه البطاقة لا تدعم هذا النوع من الشراء. استخدم بطاقة أخرى أو تواصل مع البنك.',
  'decline.incorrect_address': 'عنوان الفوترة غير صحيح. راجع البيانات وحاول مرة أخرى.',
  'decline.incorrect_zip': 'الرمز البريدي لعنوان الفوترة غير صحيح. راجع البيانات وحاول مرة أخرى.',
  'decline.invalid_expiry': 'تاريخ انتهاء البطاقة غير صحيح. راجع الشهر والسنة وحاول مرة أخرى.',
  'decline.invalid_account': 'هذه البطاقة غير متاحة للدفع. استخدم بطاقة أخرى أو تواصل مع البنك.',
  'decline.invalid_amount': 'لا يمكن دفع هذا المبلغ بهذه البطاقة. استخدم بطاقة أخرى أو تواصل مع البنك.',
  'decline.duplicate_transaction': 'تم إرسال عملية شراء بالبيانات نفسها مؤخرًا. تحقق مما إذا تم تأكيد الدفع قبل المحاولة مرة أخرى.',
  'decline.contact_issuer': 'تعذر اعتماد هذا الشراء. استخدم بطاقة أخرى أو تواصل مع البنك.',
  'decline.testmode_decline': 'لا يمكن استخدام بطاقة الاختبار هذه لهذا الشراء. استخدم بطاقة أخرى.',
  'decline.authentication_failure': 'تعذر إكمال مصادقة البطاقة. حاول مرة أخرى وأكمل التحقق.',
  'decline.card_decline_rate_limit_exceeded': 'رُفضت محاولات كثيرة للدفع بهذه البطاقة. انتظر 24 ساعة أو استخدم بطاقة أخرى.',
  'decline.card_velocity_exceeded': 'بلغت هذه البطاقة حد الرصيد أو الائتمان أو المبلغ المسموح به لكل عملية شراء. استخدم بطاقة أخرى أو تواصل مع البنك.',
  'decline.insufficient_funds': 'الرصيد غير كافٍ. استخدم بطاقة أخرى أو طريقة دفع أخرى.',
  'decline.expired_card': 'انتهت صلاحية هذه البطاقة. تحقق من تاريخ الانتهاء أو استخدم بطاقة أخرى.',
  'decline.incorrect_cvc': 'رمز أمان البطاقة غير صحيح. تحقق من CVC وحاول مرة أخرى.',
  'decline.invalid_cvc': 'رمز أمان البطاقة غير صالح. تحقق من CVC وحاول مرة أخرى.',
  'decline.incorrect_number': 'رقم البطاقة غير صحيح. راجع البيانات وحاول مرة أخرى.',
  'decline.invalid_number': 'رقم البطاقة غير صالح. راجع البيانات وحاول مرة أخرى.',
  'decline.authentication_required': 'يتطلب بنكك مصادقة هذا الشراء. حاول مرة أخرى وأكمل التحقق.',
  'decline.processing_error': 'تعذرت معالجة البطاقة الآن. حاول مرة أخرى بعد قليل.',
  'decline.issuer_not_available': 'البنك المُصدر للبطاقة غير متاح. حاول مرة أخرى بعد قليل أو استخدم بطاقة أخرى.',
  'decline.try_again_later': 'طلب البنك المحاولة مرة أخرى لاحقًا. انتظر قليلًا أو استخدم بطاقة أخرى.',
  'decline.subscriptionContext': 'تعذر تأكيد اشتراكك. {{message}}',
  'decline.default': 'تعذر إكمال الدفع. جرّب بطاقة أخرى أو طريقة دفع أخرى.',
  'payment.card': 'بطاقة', 'payment.creditCard': 'بطاقة ائتمان', 'payment.boleto': 'قسيمة دفع', 'payment.method': 'طريقة الدفع',
  'payment.express': 'دفع سريع', 'payment.otherMethods': 'طرق دفع أخرى',
  'payment.recurring': 'متكرر', 'payment.upfront': 'دفعة واحدة', 'payment.instant': 'فوري', 'payment.approved': 'مدفوع',
  'payment.pending': 'بانتظار التأكيد', 'payment.awaitingPix': 'بانتظار تأكيد Pix', 'payment.requiresAction': 'بانتظار المصادقة', 'payment.notConfirmed': 'غير مؤكد',
  'payment.firstChargePaid': 'تم دفع الرسوم الأولى', 'payment.freeTrialStarted': 'بدأت التجربة المجانية',
  'payment.cardEnding': '{{brand}} تنتهي بـ {{last4}}', 'payment.processingWallet': 'جارٍ معالجة الدفع عبر {{wallet}}…',
  'payment.completeWallet': 'أكمل الدفع في {{wallet}}',
  'payment.walletHelp': 'استخدم النافذة الآمنة المفتوحة. إذا ألغيت، ستعود حقول البطاقة تلقائيًا.',
  'payment.or': 'أو', 'payment.secureConnection': 'بيانات الدفع محمية باتصال TLS', 'payment.cardNumber': 'رقم البطاقة',
  'payment.cardholderName': 'الاسم على البطاقة', 'payment.cardholderPlaceholder': 'كما هو مكتوب على البطاقة',
  'payment.expiry': 'تاريخ الانتهاء', 'payment.cvv': 'CVV', 'payment.walletReceipt': 'سيتم إرسال التأكيد والإيصال إلى {{email}}.',
  'payment.processedBy': 'تتم معالجة الدفع بواسطة VendePay ومزود الدفع. تُعالج البيانات وفق سياسة الخصوصية.',
  'checkout.securePurchase': 'شراء آمن', 'checkout.choosePlan': 'اختر خطتك', 'checkout.bestValue': 'أفضل قيمة',
  'checkout.yourDetails': 'بياناتك', 'checkout.guest': 'اشترِ دون إنشاء حساب: يمكنك إنشاء كلمة مرور لاحقًا.',
  'checkout.payment': 'الدفع', 'checkout.completeOrder': 'أكمل طلبك', 'checkout.orderSummary': 'ملخص الطلب', 'checkout.reviewSummary': 'ملخص الشراء',
  'checkout.chargedNow': 'تم تحصيله الآن', 'checkout.totalChargedNow': 'إجمالي ما تم تحصيله الآن',
  'checkout.awaitingConfirmation': 'بانتظار التأكيد', 'checkout.recurringCharges': 'رسوم متكررة',
  'checkout.nextCharges': 'الرسوم القادمة', 'checkout.subscriptionActive': 'الاشتراك نشط. رابط الإلغاء موجود في البريد الإلكتروني.',
  'checkout.renewsFor': 'يتجدد تلقائيًا مقابل {{value}}', 'checkout.subscribeFor': 'اشترك مقابل {{value}}',
  'checkout.payAndFinish': 'ادفع {{value}} وأكمل الشراء', 'checkout.startTrial': 'ابدأ تجربة مجانية لمدة {{days}} يومًا',
  'checkout.startFree': 'ابدأ مجانًا', 'checkout.subscribeNow': 'اشترك الآن', 'checkout.payNow': 'ادفع الآن',
  'checkout.finishWallet': 'أكمل في {{wallet}}', 'checkout.productDelivery': 'سيتم تسليم المنتج بواسطة البائع.',
  'checkout.confirmationSent': 'أرسلنا التأكيد إلى {{email}}. {{delivery}}',
  'checkout.guarantee': 'ضمان {{days}} يومًا', 'checkout.fullRefundGuarantee': 'ضمان {{days}} يومًا: استرداد كامل',
  'checkout.secureEncrypted': 'دفع آمن · بيانات مشفرة', 'checkout.dataProtected': 'البيانات محمية',
  'checkout.cardNotStored': 'لا نخزن بطاقتك',
  'coupon.percentDiscount': 'خصم بنسبة مئوية',
  'coupon.fixedDiscount': 'خصم ثابت',
  "coupon.appliesToProduct": "يُطبّق الخصم على {{product}} فقط.",
  "summary.purchaseItems": "عناصر هذا الشراء",
  "summary.purchaseTotal": "إجمالي هذا الشراء",
  'coupon.beforeDiscount': 'المبلغ قبل القسيمة',
  'coupon.discountAmount': 'الخصم المطبق',
  'coupon.afterDiscount': 'المبلغ بعد القسيمة',
  'coupon.label': 'قسيمة {{code}}', 'coupon.applied': 'تم تطبيق القسيمة', 'coupon.remove': 'إزالة',
  'coupon.code': 'رمز القسيمة', 'coupon.validating': 'جارٍ التحقق…', 'coupon.apply': 'تطبيق', 'coupon.haveOne': 'هل لديك قسيمة؟',
  'coupon.invalid': 'القسيمة غير صالحة أو منتهية.', 'summary.trialPeriod': 'فترة التجربة', 'summary.days': '{{days}} يومًا',
  'summary.totalToday': 'إجمالي اليوم', 'summary.recurringCharge': 'رسوم متكررة',
  'pending.subscriptionTitle': 'جارٍ تأكيد اشتراكك',
  'pending.subscriptionBody': 'اكتملت المصادقة. نقوم بتفعيل الفترة المجانية وسنرسل التأكيد إلى {{email}}.',
  'pending.authenticationTitle': 'المصادقة مطلوبة',
  'pending.authenticationBody': 'طلب البنك تحققًا إضافيًا. أكمل المصادقة لإنهاء الدفع.',
  'success.added': 'تمت الإضافة!', 'success.addedBody': 'تم تحصيل +{{value}} من بطاقتك.',
  'success.subscriptionTitle': 'بدأ الاشتراك!', 'success.freeDays': 'لديك {{days}} أيام مجانية. لم يتم تحصيل شيء اليوم.',
  'success.firstCharge': ' سيتم تحصيل أول دفعة بقيمة {{value}} في {{date}}.',
  'success.subscriptionEmail': 'تم إرسال التأكيد ورابط الإلغاء إلى {{email}}.', 'success.paymentTitle': 'تمت الموافقة على الدفع!',
  'subscription.single': 'اشتراك', 'subscription.oneTime': 'شراء لمرة واحدة',
  'subscription.bumpTerms': 'اشتراك بالبطاقة: يتجدد تلقائيًا. يمكنك الإلغاء من الرابط المرسل بالبريد الإلكتروني.',
  'subscription.afterPaidTrialTerms': 'بعد أول {{days}} يومًا، يتجدد تلقائيًا مقابل ',
  'subscription.freeTerms': '{{days}} أيام مجانية، دون رسوم اليوم. ثم ',
  'subscription.renewalTerms': 'تجديد تلقائي: ', 'subscription.cancelTerms': '. يمكنك الإلغاء في نهاية الفترة عبر رابط البريد الإلكتروني.',
  'upsell.downsellBadge': 'انتظر! عرض خاص', 'upsell.badge': 'عرض حصري لفترة محدودة',
  'upsell.addCard': 'نعم، أضف +{{value}} إلى بطاقتي', 'upsell.continueWithout': 'المتابعة دون هذا العرض',
  'upsell.reassurance': 'تمت الموافقة على الدفع: قبل الإنهاء، عرض حصري',
  'upsell.trialDays': '{{days}} أيام تجريبية', 'upsell.oneClick': 'شراء آمن بنقرة واحدة',
  'upsell.noCardAgain': 'لا حاجة لإدخال البطاقة مرة أخرى', 'installment.label': '{{count}} دفعات بقيمة {{value}}',
  'legacy.urgency': 'عرض لفترة محدودة', 'legacy.reassurance': 'شراء محمي · وصول فوري بعد الدفع',
  'upsell.accept': 'نعم، أريده', 'upsell.reject': 'لا، شكرًا',
});
